import { render, staticRenderFns } from "./NsMiniCart.vue?vue&type=template&id=69cc5a4c&scoped=true&"
import script from "./NsMiniCart.vue?vue&type=script&lang=js&"
export * from "./NsMiniCart.vue?vue&type=script&lang=js&"
import style0 from "./NsMiniCart.vue?vue&type=style&index=0&id=69cc5a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cc5a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69cc5a4c')) {
      api.createRecord('69cc5a4c', component.options)
    } else {
      api.reload('69cc5a4c', component.options)
    }
    module.hot.accept("./NsMiniCart.vue?vue&type=template&id=69cc5a4c&scoped=true&", function () {
      api.rerender('69cc5a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsMiniCart.vue"
export default component.exports